module.exports = __webpack_public_path__ + "img/airManagement.702b9c65.jpg";